/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

function route (pathObj) {
  return {
    name: pathObj.name || pathObj.view,
    path: pathObj.path,
    meta: pathObj.meta,
    props: route => ({ query: route.query }),
    component: r => pathObj.component.then(r)
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  // mode: 'history',
  routes: paths.map(path => route(path)).concat([
    { path: '*', redirect: '/dashboard' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

Vue.use(Meta)

export default router
